export default __webpack_public_path__ + "static/media/buy1.0f2ccb4e.png";